(() => {
  /*
   * Prevent duplicate event listeners when more than one
   * image-banner section appears on the page.
   */
  if (window.imageBannerDiscountCopyInitialized) {
    return;
  }

  window.imageBannerDiscountCopyInitialized = true;

  /**
   * Older-browser fallback for copying text.
   *
   * @param {string} value
   * @returns {boolean}
   */
  function fallbackCopy(value) {
    const textarea = document.createElement('textarea');

    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.setAttribute('aria-hidden', 'true');

    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    let successful = false;

    try {
      successful = document.execCommand('copy');
    } catch (error) {
      successful = false;
    }

    textarea.remove();

    return successful;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-discount-copy]');

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const code = button.dataset.code?.trim();

    if (!code) {
      return;
    }

    let copied = false;

    /*
     * Preferred Clipboard API.
     */
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(code);
        copied = true;
      }
    } catch (error) {
      copied = false;
    }

    /*
     * Fallback for browsers where navigator.clipboard
     * is unavailable or denied.
     */
    if (!copied) {
      copied = fallbackCopy(code);
    }

    if (!copied) {
      button.classList.add('is-copy-error');
      button.setAttribute(
        'aria-label',
        `Could not copy discount code ${code}`
      );

      return;
    }

    const textElement = button.querySelector('[data-discount-text]');
    const copiedLabel = button.dataset.copiedLabel || 'copied!';

    if (textElement) {
      textElement.textContent = copiedLabel;
    }

    button.classList.remove('is-copy-error');
    button.classList.add('is-copied');
    button.setAttribute(
      'aria-label',
      `${copiedLabel} ${code}`
    );
  });
})();